import moment from 'moment-timezone';

const localizedDate = (date, format) => {
  const timezone = moment.tz.guess();

  console.log('localizedDate!');
  console.log('timezone', timezone);

  moment.tz.setDefault(timezone);

  return moment.tz(date, timezone).format(format);
};

export const unformatted_localizedDate = date => {
  const timezone = moment.tz.guess();

  console.log('localizedDate!');
  console.log('timezone', timezone);

  moment.tz.setDefault(timezone);

  return moment.tz(date, timezone);
};

export default localizedDate;
